"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const MultiSamplePicker_1 = require("../../sample/MultiSamplePicker");
function useSelectFirstRealSample({ onSelectSample, samples, selectedSampleId, }) {
    const selectedSample = MultiSamplePicker_1.findSelectedSample({ samples, selectedSampleId });
    const firstRealSample = MultiSamplePicker_1.findFirstRealSample(samples);
    react_1.useEffect(() => {
        if (selectedSample && MultiSamplePicker_1.wasSkipped(selectedSample) && firstRealSample) {
            onSelectSample(MultiSamplePicker_1.getSampleId(firstRealSample));
        }
    }, [firstRealSample, onSelectSample, selectedSample]);
}
exports.default = useSelectFirstRealSample;
